// @flow

import React, { type Node } from 'react';
import {
  InstructionsContainer,
  SingleInstructionWrapperDiv,
  SingleInstructionDiv,
  CircleBgDiv,
} from '../../../organisms/shared-styled-components';

type InstructionProps = {|
  eBankingValue: string,
  eBankingOptions: Object,
  ignoreFirstOption?: boolean,
|};

export function RenderTheInstructions({eBankingValue, eBankingOptions, ignoreFirstOption=null}: InstructionProps): Node {
  const ebankingOptionKeys = Object.values(eBankingOptions[eBankingValue]);
  // first element is not an instruction, see app/look-and-feel/volcanes/pages/page-pending-payment/cash-page/render-helpers.js#RenderTransferNode and RenderDepositNode
  if (ignoreFirstOption) {
    ebankingOptionKeys.shift();
  }
  return (
    <InstructionsContainer>
      {ebankingOptionKeys.map((option, index) => {
        return (
          <SingleInstructionWrapperDiv key={index}>
            <CircleBgDiv>{(index + 1)}</CircleBgDiv>
            <SingleInstructionDiv key={index}>{option}</SingleInstructionDiv>
          </SingleInstructionWrapperDiv>
        );
      })}
    </InstructionsContainer>
  );
}
